import { useRef } from "react";
import { ACCENTS } from "../../constants/accents.js";
import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { usePickerOpen, useSetPickerOpen } from "../../logic/stores/uiStore.js";
import { Ico } from "../icons/icons.jsx";
import { Tip } from "../ui/Tooltip.jsx";
import { FloatingPanel, useDismissOnOutsideClick } from "../ui/FloatingPanel.jsx";

export function SidebarAccentPicker({ setHoveredTip, setTipRect }) {
  const { accent, setAccent, dark, setDark, c, accentHex: A } = useThemeSlice();
  const pickerOpen = usePickerOpen();
  const setPickerOpen = useSetPickerOpen();
  const anchorRef = useRef(null);
  const panelRef = useRef(null);

  useDismissOnOutsideClick(pickerOpen, () => setPickerOpen(false), [anchorRef, panelRef]);

  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <Tip setHoveredTip={setHoveredTip} setTipRect={setTipRect} id="accent-btn" label="Accent color" side="top" fullWidth>
        <button
          ref={anchorRef}
          type="button"
          onClick={() => setPickerOpen(!pickerOpen)}
          onMouseEnter={(e) => (e.currentTarget.style.background = c.hover)}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
          style={{ width: "100%", height: 36, display: "flex", alignItems: "center", justifyContent: "center", border: "none", background: "transparent", cursor: "pointer" }}
        >
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: A, display: "block" }} />
        </button>
      </Tip>
      <FloatingPanel anchorRef={anchorRef} panelRef={panelRef} open={pickerOpen} align="end" preferAbove minWidth={155} gap={6}>
        <div className="nemo-popover" style={{ background: c.sb, border: `1px solid ${c.sbBdr}`, borderRadius: 8, padding: "12px 10px" }}>
          <p style={{ fontSize: 9.5, color: c.sub, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 7, paddingLeft: 4 }}>Accent</p>
          {ACCENTS.map((a) => {
            const sel = accent.name === a.name;
            return (
              <button
                key={a.name}
                type="button"
                onClick={() => { setAccent(a); setPickerOpen(false); }}
                onMouseEnter={(e) => { if (!sel) e.currentTarget.style.background = c.hover; }}
                onMouseLeave={(e) => { if (!sel) e.currentTarget.style.background = "transparent"; }}
                style={{ display: "flex", alignItems: "center", gap: 9, padding: "6px 8px", width: "100%", borderRadius: 6, border: "none", background: sel ? c.hover : "transparent", cursor: "pointer", color: c.text, fontSize: 12, fontWeight: sel ? 600 : 400 }}
              >
                <span style={{ width: 12, height: 12, borderRadius: "50%", background: a.hex, flexShrink: 0 }} />
                {a.name}
                {sel && <span style={{ marginLeft: "auto", color: a.hex, display: "flex" }}>{Ico.check}</span>}
              </button>
            );
          })}
          <div style={{ height: 1, background: c.divider, margin: "9px 0" }} />
          <div style={{ display: "flex", gap: 4 }}>
            {[["Light", false], ["Dark", true]].map(([label, d]) => (
              <button
                key={label}
                type="button"
                onClick={() => setDark(d)}
                style={{ flex: 1, padding: "5px 0", borderRadius: 5, cursor: "pointer", fontSize: 11, fontWeight: dark === d ? 600 : 400, background: dark === d ? c.aLight : "transparent", border: `1px solid ${dark === d ? A + "60" : c.sbBdr}`, color: dark === d ? A : c.mid }}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </FloatingPanel>
    </div>
  );
}
